import axios from 'axios';
import api from './endpoints';

export default {
  list(args) {
    const params = {
        page: args.page || 1,
        size: args.size || 10,
        filter: args.filter,
        group: args.group,
        sortBy: args.sortBy,
        sortDesc: args.sortDesc,
        variant: args.variant,
      };

    if (args.type) {
      params.type = args.type;
    }

    if (args.volunteers) {
      params.volunteer = args.volunteers
    }

    return axios.get(api.resolveEndpoint(api.EVENT_PARTICIPANTS, [args.eventId]), {
      params
    }).then((data) => data.data);
  },
  detail(args) {
    return axios.get(api.resolveEndpoint(api.EVENT_PARTICIPANTS_DETAIL, [args.eventId, args.userId])).then((data) => data.data);
  },
  edit(args) {
    return axios.put(api.resolveEndpoint(api.EVENT_PARTICIPANTS_DETAIL, [args.eventId, args.participantId]), args).then((data) => data.data);
  },
  unsubscribe(args) {
    return axios.put(api.resolveEndpoint(api.EVENT_PARTICIPANTS_UNSUBSCRIBE, [args.eventId, args.userId])).then((data) => data.data);
  },
  subscribe(args) {
    return axios.put(api.resolveEndpoint(api.EVENT_PARTICIPANTS_SUBSCRIBE, [args.eventId, args.userId])).then((data) => data.data);
  }
};
